import { DataBean } from "../DataBean";

export class CashFlowConcept extends DataBean {


    public async getCashFlowConceptCatalog(idCashFlowConcept:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashFlowConceptCatalog_Number", [idCashFlowConcept]);
    }

  
    

 
}